import { State } from '../../types';

export const arkansas: State = {
  name: 'Arkansas',
  abbreviation: 'AR',
  terms: [
    {
      word: 'Alma',
      phonetic: 'AL-muh',
      // audioUrl: '/audio/arkansas.mp3',
      description: 'Known as the Spinach Capital of the World, this town is located in western Arkansas.'
    },
    {
      word: 'Arkansas',
      phonetic: 'AR-kan-saw',
      // audioUrl: '/audio/arkansas.mp3',
      description: 'State name pronunciation'
    },
    {
      word: 'Bellefonte',
      phonetic: 'Bell-FONT',
      // audioUrl: '/audio/arkansas.mp3',
      description: 'A small town near Harrison with French roots in its name.'
    },
    {
      word: 'Blytheville',
      phonetic: 'BLUV-ul',
      // audioUrl: '/audio/arkansas.mp3',
      description: 'A city in northeastern Arkansas, known for its ties to agriculture and air force history.'
    },
    {
      word: 'Bois d’Arc',
      phonetic: 'Bo-DART',
      // audioUrl: '/audio/arkansas.mp3',
      description: 'A rural area named after the bois d’arc tree, also known as the Osage orange tree.'
    },
    {
      word: 'Ouachita',
      phonetic: 'WASH-i-taw',
      // audioUrl: '/audio/arkansas.mp3',
      description: 'A mountain range and river, often mispronounced as "Ooh-a-chee-tah."'
    },
    {
      word: 'Fouke',
      phonetic: 'Foke',
      // audioUrl: '/audio/arkansas.mp3',
      description: 'A city in Arkansas, commonly mispronounced as "FOO-kee."'
    },
    {
      word: 'Lavaca',
      phonetic: 'La-VAH-kah',
      // audioUrl: '/audio/arkansas.mp3',
      description: 'A small town near Fort Smith, often mistaken for the Spanish phrase meaning “the cow.”'
    },
    {
      word: 'Petit Jean',
      phonetic: 'PET-ee jeen',
      // audioUrl: '/audio/arkansas.mp3',
      description: 'A state park and mountain in central Arkansas'
    }
  ]
};